import appmixer from '../../plugins/appmixer';

export default class EngineVersionRequests {
    getEngineInfo() {
        return appmixer.api.request({
            url: `${appmixer.api.get('baseUrl')}`,
            method: 'GET'
        });
    }
};
